<template>
    <div class="ot-wrapper">
        <UiOtNotice id="UiOtNotice" :blok="blok" />
    </div>
</template>

<script setup lang="ts">
import type { IOtNoticeSection } from '@nuxt-monorepo/ui/types/components/OtNotice';

defineProps<{ blok: IOtNoticeSection }>();
</script>

<style lang="postcss" scoped>
.ot-wrapper {
    @apply pt-12 bg-[#f2f2f2] pb-12;
}
#UiOtNotice {
    @apply px-4;
    :deep(h1) {
        @apply ml-0 md:ml-16 mt-12 mb-8 text-[32px] md:text-4xl leading-9 md:leading-[44px] font-medium md:font-semibold;
        @apply text-[#424652] md:text-[#505050];
    }
    :deep(.otnotice-menu) {
        @apply max-h-[80%];
    }
    :deep(.otnotice-section-content) {
        @apply mx-2 md:mr-0 md:ml-10;
        p {
            @apply text-sm text-[#5a5e6b];
        }
    }

    :deep(h2.otnotice-section-header) {
        @apply mx-2  md:mr-0 md:ml-10;
    }

    :deep(a) {
        @apply text-primary;
        &:hover {
            @apply brightness-90;
        }
    }
}
</style>
